import * as Sentry from '@sentry/react';
import { env } from '../constants/env';

Sentry.init({
  dsn: env.SENTRY_DSN,
  tunnel: `${env.SERVER_URL}/sentry-tunnel`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.MODE === 'production',
});

export default Sentry;
